// extracted by mini-css-extract-plugin
module.exports = {"whatsappChannelNotIncluded":"SettingPlan_whatsappChannelNotIncluded__A91ZN","subscriptionPlanContainer":"SettingPlan_subscriptionPlanContainer__2F3ND"};